/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {Link} from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {connect} from "react-redux";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import Translate from "../../utils/utils";

class UserProfile extends React.Component {

    render() {
        const {user: {first_name, role}, showHi} = this.props;

        return (
            <Dropdown className="kt-header__topbar-item kt-header__topbar-item--user pull-right" drop="down" alignRight>
                <Dropdown.Toggle
                    as={HeaderDropdownToggle}
                    id="dropdown-toggle-user-profile"
                >
                    <div className="kt-header__topbar-user">
                        {showHi && (
                            <span className="kt-header__topbar-welcome kt-hidden-mobile">
                Hi,
              </span>
                        )}

                        {showHi && (
                            <span className="kt-header__topbar-username kt-hidden-mobile">
                {first_name}
              </span>
                        )}
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                    className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
                    <div
                        className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                    >
                        <div className="kt-user-card__avatar">
                            <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                {role.name.charAt(0)}
              </span>
                        </div>
                        <div className="kt-user-card__name">{role.name}</div>
                    </div>
                    <div className="kt-notification">
                        <div className="kt-notification__item">
                            <div className="kt-notification__item-icon">
                                <i className="flaticon-profile-1 kt-font-success"/>
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title kt-font-bold">
                                    <Link to="/user/profile"><Translate id="PROFILE.BUTTON"/></Link>
                                </div>
                            </div>
                        </div>
                        <div className="kt-notification__item">
                            <div className="kt-notification__item-icon">
                                <i className="flaticon-lock kt-font-success"/>
                            </div>
                            <div className="kt-notification__item-details">
                                <div className="kt-notification__item-title kt-font-bold">
                                    <Link to="/user/password"><Translate id="PROFILE.SECURITY"/></Link>
                                </div>
                            </div>
                        </div>
                        <div className="kt-notification__custom">
                            <Link
                                to="/logout"
                                className="btn btn-label-brand btn-sm btn-bold"
                            >
                                <Translate id="AUTH.BUTTON.LOGOUT"/>
                            </Link>
                        </div>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

const mapStateToProps = ({auth: {user}}) => ({
    user
});

export default connect(mapStateToProps)(UserProfile);
